$(document).ready(function()
{
    $(document).foundation();

     $('html').removeAttr("style");

    window.addEventListener("load", function()
    {
        if( window.cookieconsent ) 
        {
            window.cookieconsent.initialise({
                
                palette: {
                    popup: {
                        background: "#4b5771",
                        text: "#fff",
                        link: '#fff'
                    },
                    button: {
                        background: "#ffffff",
                        text: '#2256aa'
                    }
                },
                theme: "edgeless",
                content: {
                    message: "This website uses cookies to ensure you get the best experience.",
                    href: "/terms-and-conditions/#cookies",
                    dismiss: 'Allow',
                },
                dismissOnScroll: true
            });
        }
    });


    // track language changes
    function languageTranslatedTracking()
    {
        $('html').change(function()
        {
            setTimeout(function()
            {
                var newLanguageHTML = $('html').attr("lang");
                if (newLanguageHTML != currentLanguageHTML && newLanguageHTML != "")
                {
                    currentLanguageHTML = newLanguageHTML;
                    ga('send', 'event', 'Translation', 'GoogleTranslate', currentLanguageHTML);
                }
            }, 1000);
        });
    }
    var currentLanguageHTML = $('html').attr("lang");
    languageTranslatedTracking();

    if ($(".social-buttons").length) {
        $( '.social-buttons a' ).click(function( e ){
            e.preventDefault();
            m40_socialShare( this.href, 640, 480 );
        });
        window.m40_socialShare = function(url, winWidth, winHeight) {
            var winTop = (window.innerHeight / 2) - (winHeight / 2);
            var winLeft = (window.innerWidth / 2) - (winWidth / 2);
            window.open(url, 'm40_sharer', 'top=' + winTop + ',left=' + winLeft + ',toolbar=0,status=0,width=' + winWidth + ',height=' + winHeight);
            return false;
        };
    }

    if ($(".chosen").length) {
        $(".chosen > .ginput_container > select").chosen();
    }

    if ($(".flatpickr").length) {
        $(".flatpickr > .ginput_container > input").flatpickr();
    }

    if ($(window).width() < 1025)
    {
        $("#gbox_div").prependTo("#gbox_mobile");
    }

    // Search Container - Trigger is in secondary-navigation.twig
    $("#search-trigger, #search-trigger-mobile").on('click', function(e) {
        e.preventDefault();

        // can't be sa simple toggle as there's so much to turn off and on
        if ($(".search-container").hasClass("active"))
        {
            $(".search-container").removeClass("active");
            $(".search-container").removeClass("down");
            $(".search-active-overlay").removeClass("fade-content");
            $("html").removeClass("no-scroll");
        }
        else
        {
            $(".search-container").addClass("active");
            $(".search-active-overlay").addClass("fade-content");
            $("html").addClass("no-scroll");
        }
    });

    $(".search-close").on('click', function(e) {
        e.preventDefault();
        $(".search-container").removeClass("active");
        $(".search-container").removeClass("down");
        $(".search-active-overlay").removeClass("fade-content");
        $("html").removeClass("no-scroll");
    });
    $("#s-head").on('click', function()
    {   
        $("#search-container").addClass("active");
        $("#search-container").addClass("down");
        $(".search-active-overlay").addClass("fade-content");
        $("html").addClass("no-scroll");
    });



    $( '.news-item' ).hover(function(){
        $( this ).toggleClass( 'is-active' );
    });

    $( '.news-item' ).click(function(){
        $(this).find('a')[0].click();
    });

    // esc key action
    $(document).keyup(function(e) 
    {
        if (e.keyCode == 27) { // Esc
            $(".search-container").removeClass("active");
            $("html").removeClass("nav-is-open");
            $("#primary-nav").removeClass("nav-open");
            $('#featuredInfoWindow').slideUp();
            $('.menu-item').removeClass('faux-focus');
            //$("#search-head-container-accordion-group").removeClass('accordion-open');

            let accordion_group = $("#search-head-accordion-group").data('accordion-group');
            if(accordion_group)
            {
                accordion_group.set_open(null, false);
            }

            $(this).blur();
        }
    });



    // accessibility stuff
    $(document).on('keypress',function(e) 
    {
        if(e.which == 13) 
        {
            var is_active = document.activeElement;
            if(is_active.classList.contains('cc-dismiss') || is_active.classList.contains('close-search-always') || is_active.classList.contains('auto-submit') || is_active.classList.contains('accordion-button') || is_active.classList.contains('menu-open') )
            {
                is_active.click();
            }
            if(is_active.classList.contains('radio-wrapper'))
            {
                var closingChildren = is_active.getElementsByClassName("auto-submit");

                if (closingChildren)
                {
                    for (var i = 0; i < closingChildren.length; i++) 
                    {
                        closingChildren[i].click();
                    }
                }
            }
            if(is_active.classList.contains('search-head-close-overlay'))
            {

                let accordion_group = $("#search-head-accordion-group").data('accordion-group');
                if(accordion_group){
                    accordion_group.set_open(null, false);
                }
            }
        }
    });


    $('#article-select-wrapper').hide();


    $(".no-jump").on('click', function(e)
    {
        e.preventDefault();
    });


    // Set a variable for our button element.
    var scrollToTopButton = document.getElementById('js-return-top');

    // Let's set up a function that shows our scroll-to-top button if we scroll beyond the height of the initial window.
    function scrollFunc() 
    {
      // Get the current scroll value
      var y = window.scrollY;
      
      // If the scroll value is greater than the window height, let's add a class to the scroll-to-top button to show it!
      if (y > 0) 
      {
            scrollToTopButton.className = "return-top-link show";
            //$("html").addClass("sticky-nav");
            if ($(window).width() > 1025)
            {
                $("#gbox_div").prependTo("#gbox_mobile");
            }
      } 
      else 
      {
            scrollToTopButton.className = "return-top-link hide";
            //$("html").removeClass("sticky-nav");
            if ($(window).width() > 1025)
            {
                $("#gbox_div").prependTo("#gbox_desktop");
            }
      }
    }

    window.addEventListener("scroll", scrollFunc);

    function scrollToTop() 
    {
        $("html, body").animate({ scrollTop: 0 }, 500);
        return false;
    }

    // When the button is clicked, run our ScrolltoTop function above!
    scrollToTopButton.onclick = function(e) 
    {
      e.preventDefault();
      scrollToTop();
    }

    /* FORM MODAL */

        var $protectedLinks = $('.protected-download');
        var $downloadButton = $('.downloads-button');
        var $emailCaptureModal = $('#emailCaptureModal');


        if( $('#take-over').length > 0 )
        {
            $('#take-over').foundation('open');
        }

        $('.dont-show-again').on('click', function() {
            $modalTitle = $('#take-over').data('title');

            $('#take-over').foundation('close');

            //Cookies.set('dontShowHomepageModal', $modalTitle, { expires: 14 });
            var date = new Date();
            date.setTime(date.getTime() + (30*24*60*60*1000)); // 1 month
            document.cookie = 'dontShowHomepageModal' + "=" + "1"  + "; expires=" + date.toUTCString() + "; path=/";

            return false;
        });


        jQuery(document).bind('gform_confirmation_loaded', function(event, formId){
            $protectedLinks.removeClass('hide');
            $('#restricted-access').addClass('hide');
            $('#emailCaptureModal').foundation('close');
        });


        /* FORM MODAL END */

     // window.FontAwesomeConfig.searchPseudoElements = true;


       $(".clickable-row").click(function() {
            //window.location = $(this).data("href");
        });

        // Submit form on radio click
        $(".auto-submit").click(function() 
        {
            $(this).closest("form").submit();
        });


        $(".location_choice").change(function()
        {
            var choice = $(this).val();
            if (choice == "input")
            {
                 $("#location-geocode-on").addClass("hide");
            }
            else
            {
                $("#location-input-on").addClass("hide");
                $("#search_address").val = "";
            }
        });

        $('#form_open_again, #form_redo').click(function(e)
        {
            e.preventDefault();
            $("#form_open_again").toggleClass("down");
            $("#solicitor_finder_form").toggleClass("hide");
            $("#form_matching_results").toggleClass("hide"); 
            if ($( "#form_redo" ).text() == "Hide search filters")
            {
                $("#form_redo").text("Show search filters");
            }
            else
            {
                $("#form_redo").text("Hide search filters");    
            }
            
            return false;
        });

    // fiddly group of rules to handle focus/rollover menus in an accessible way
    $( ".apply-faux-focus" ).on( "focus mouseover", function() 
    {
        $('.menu-item').removeClass('faux-focus');
        $(this).parent().addClass('faux-focus');
    });
    $( ".main-menu").on ("mouseleave", function()
    {
        $('.menu-item').removeClass('faux-focus');
    });
    $( ".faux-focus-final" ).on( "focusout", function() 
    {
        $('.menu-item').removeClass('faux-focus');
    });

    $('#search-head-trigger-mobile, #search-head-trigger-desktop').click(function()
    {
        $('#search-head-input').focus();
    });

});



function getSimpleValue( el )
{
    var myInput = document.getElementById(el);
    if (myInput && myInput.innerHTML && myInput.innerHTML.length > 0) {
      return myInput.innerHTML;
    }
    return false;
}



function getDistanceBetween(lat1, lon1, lat2, lon2, unit) {
    if ((lat1 == lat2) && (lon1 == lon2)) {
        return 0;
    }
    else {
        var radlat1 = Math.PI * lat1/180;
        var radlat2 = Math.PI * lat2/180;
        var theta = lon1-lon2;
        var radtheta = Math.PI * theta/180;
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
            dist = 1;
        }
        dist = Math.acos(dist);
        dist = dist * 180/Math.PI;
        dist = dist * 60 * 1.1515;
        if (unit=="K") { dist = dist * 1.609344 }
        if (unit=="N") { dist = dist * 0.8684 }

        if (dist < 10)
        {
            return roundPoint2(dist, 2);
        }
        else
        {
            return roundPoint2(dist, 0);
        }
    }
}

function roundPoint2 (_n,d) {
    return (Math.round (_n*Math.pow(10,d)))/Math.pow(10,d);
}